<template>
  <div class="page1">
    <EForm :formColumns="formColumns" :rowSize="5" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
      ref="form" @onSearch="onSearch" :searchFlag="true" :exportShow="false"></EForm>
    <el-button @click="dialogVisible = true">新增</el-button>
    <el-button type="danger" size="small" plain @click="deleteMore">删除</el-button>
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="true" :count="count"
      @changePage="changePage" @changeSize="changeSize" :page="searchForm.current" :page_size="searchForm.size" @handleSelect="handleSelectionChange"
            :needSelect="true">
      <el-table-column fixed="right" label="操作" width="180px">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="editDialog(scope.row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="40%"
      @handleClick="saveData">
      <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="字典编号" prop="dictCode">
              <el-input v-model="form.dictCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="字典名称" prop="dictName">
              <el-input v-model="form.dictName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="字典值" prop="dictValue">
              <el-input v-model="form.dictValue"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable'
import Http from "@/service/http";
import EDialog from '@/components/EDialog'
import EButton from '@/components/EButton'
import EForm from '@/components/EForm'
import vxRule from "@/assets/js/formValidate";
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      formColumns: [
        {
          title: '字典编号',
          type: 'text',
          property: 'dictCode',
          placeHolder: '请输入',
          show: true,
        },
        {
          title: '字典名称',
          type: 'text',
          property: 'dictName',
          placeHolder: '请输入',
          show: true,
        }],
      tableTitle: [
        {
          label: '字典编号',
          prop: 'dictCode',
        },
        {
          label: '字典名称',
          prop: 'dictName',
        },
        {
          label: '字典值',
          prop: 'dictValue',
        },
        {
          label: '创建时间',
          prop: 'createTime',
        }],
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: '添加信息',
      form: {
        id: '',
        dictCode: '',
        dictName: '',
        dictValue: ''
      },
      searchForm: {
        dictCode: '',
        dictName: '',
        current: 1,
        size: 10
      },
      cascader: false,
      options: [],
      count: null,
      formRules: {
        dictCode: [vxRule(true, '', "blur", "字典编号不能为空")],
        dictName: [vxRule(true, '', "blur", "字典名称不能为空")],
      },
      labelPosition: 'right',
      labelWidth: '100px',
      selectRoutes: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  created() {
    this.getData()
    //this.getOptions()
  },
  components: { ETable, EDialog, EButton, EForm },
  beforeMount() {

  },
  methods: {
    onSearch() {
      this.searchForm.current = 1
      this.getData()
    },
    changePage(page) {
      this.searchForm.current = page
      this.getData()
    },
    changeSize(size) {
      this.searchForm.size = size
      this.getData()
    },
    handleClose() {
      this.title = '添加信息'
      this.dialogVisible = false
      this.form = {
        id: '',
        dictCode: '',
        dictName: '',
        dictValue: ''
      }
      this.$refs.form.resetFields()
    },
    handleSelectionChange(data) {
        if (data.length > 0) {
          data.forEach((item) => {
            this.selectRoutes.push(item.id);
          });
        }
      },
    deleteMore() {
      this.deleteInfo(this.selectRoutes.toString());
    },
    deleteInfo(ids) {
      this.$messageBox
        .confirm(`确定删除该信息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then((res) => {
          this.removeRoute(ids);
        })
        .catch((res) => {});
    },
    async getData() {
      let res = await Http.bigScreenDictList(this.searchForm)
      if (res.code == 200) {
        this.tableData = res.data.records
        this.count = res.data.total
      }

    },
    saveData() {
      let flag = false
      this.$refs['form'].validate((valid, object) => {
        if (valid && !this.error) {
          flag = true
        } else {
          return false;
        }
      });
      if (flag) {
        this.addBtn()
      }
    },
    async addBtn() {
      let {
        id,
        dictCode,
        dictName,
        dictValue
      } = this.form
      let res = await Http.bigScreenDictSave({
        id,
        dictCode,
        dictName,
        dictValue
      })
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.handleClose()
        this.getData()
      }
    },
    editDialog(data) {
      this.title = '编辑信息'
      this.form = {
        id: data.id,
        dictCode: data.dictCode,
        dictName: data.dictName,
        dictValue: data.dictValue,
      }
      this.dialogVisible = true
    },
    async removeRoute(ids) {
      let res = await Http.bigScreenDictRemoveRoute({ ids });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;

}
</style>
